'use client';

import { Alert, Button } from '@/components';
import { useKycValidation } from '@/hooks';

import { RECOVERY_MESSAGES } from '../../constants';

type RecoveryKycVerificationProps = {
  customerId: string;
  onStartValidation: () => void;
  onBackToLogin: () => void;
};

export const RecoveryKycVerification = ({
  customerId,
  onStartValidation,
  onBackToLogin,
}: RecoveryKycVerificationProps) => {
  const { cpf, hashCpf, isLoadingHash, isExatoReady } = useKycValidation({
    customerId,
  });

  const isButtonDisabled = !cpf || !hashCpf || !isExatoReady || isLoadingHash;

  return (
    <div className="flex flex-col gap-4 p-2 text-center">
      <div>
        <h2 className="text-lg font-semibold text-foreground">
          {RECOVERY_MESSAGES.KYC_TITLE}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          {RECOVERY_MESSAGES.KYC_DESCRIPTION}
        </p>
      </div>

      <Alert
        variant="info"
        title="Como funciona"
        description="Vamos abrir a verificação facial da Exato Digital para confirmar que a conta é sua antes de trocar o telefone."
      />

      <Button
        variant="secondary"
        id="exDocCheckAction"
        loading={isLoadingHash}
        disabled={isButtonDisabled}
        onClick={onStartValidation}
        data-ex-doccheck-document={cpf}
        data-ex-doccheck-document-hmac-hash={hashCpf}
        loadingText="Preparando validação..."
        className="h-12 w-full text-base"
      >
        Verificar identidade
      </Button>

      <Button type="button" variant="link" className="mx-auto" onClick={onBackToLogin}>
        Voltar ao login
      </Button>
    </div>
  );
};
